import {SelectAction } from "../../components/select";
import { TaskActionsProps } from "./Task.types";
import { useTaskActions } from "./useTaskActions";

export function TaskActions({onActionSelected, task, user}: TaskActionsProps) {
    const {getActions} = useTaskActions()
    return <SelectAction defaultLabel="Task Actions" options={getActions(task, user)} onChange={onActionSelected} />
}